import { useEffect, useState } from 'react';
import { LabelValue } from '../types/label-value.types';
import Button from './button';
import AppDatePicker from './form/base/app-datepicker';
import AppTimePicker from './form/base/app-time-picker';
import AppSelect from './form/base/app-select';
import './time-filters.scss';
import dayjs, { Dayjs } from 'dayjs';
import dateService from '../services/date.service';
import { useSelector } from 'react-redux';
import { AppStore } from '../store/store';
import { UserState } from '../store/user.slice';
import { attachAxiosApiInterceptors } from '../utils/axios-utils';

const timeOptions: LabelValue[] = [
    {
        label: 'Reset',
        value: '',
    },
    {
        label: 'DAY',
        value: 'day'
    },
    {
        label: 'WEEK',
        value: 'week'
    },
    {
        label: 'MONTH',
        value: 'month',
    },
    {
        label: 'YEAR',
        value: 'year'
    },
    {
        label: 'INTERVAL',
        value: 'interval',
    },
];

const timeOptionsMonth: LabelValue[] = [{
    label: 'MONTH',
    value: 'month',
},]

const months = [
    { label: 'January', value: '1' },
    { label: 'February', value: '2' },
    { label: 'March', value: '3' },
    { label: 'April', value: '4' },
    { label: 'May', value: '5' },
    { label: 'June', value: '6' },
    { label: 'July', value: '7' },
    { label: 'August', value: '8' },
    { label: 'September', value: '9' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' }
];

const years = Array.from({ length: new Date().getFullYear() - 2010 + 1 }, (v, k) => ({
    label: `${2010 + k}`,
    value: `${2010 + k}`
}));


interface TimeFiltersProps {
    transactionsNo?: number;
    handleFilters: (startDate?: string, endDate?: string) => void
    resetTrigger?: boolean;
    dontShowTransactionsNo?: boolean;
    filterOnlyMonth?: boolean;
}


const TimeFilters: React.FC<TimeFiltersProps> = ({ transactionsNo, handleFilters, resetTrigger, dontShowTransactionsNo, filterOnlyMonth = false }) => {
    const [time, setTime] = useState<string>();

    const [selectedDayDate, setSelectedDayDate] = useState<Dayjs | null>();
    const [thisButton, setThisButton] = useState(false);
    const [lastButton, setLastButton] = useState(false);
    const [last7Days, setLast7Days] = useState(false); 
    const [selectedMonth, setSelectedMonth] = useState<string>();
    const [selectedYear, setSelectedYear] = useState<string>();
    const [selectedFromDate, setSelectedFromDate] = useState<Dayjs | null>();
    const [selectedToDate, setSelectedToDate] = useState<Dayjs | null>();
    const [selectedFromTime, setSelectedFromTime] = useState<string | null>(null);
    const [selectedToTime, setSelectedToTime] = useState<string | null>(null);




    useEffect(() => {
        setTime(undefined);
        setSelectedDayDate(null);
        setSelectedMonth(undefined);
        setSelectedYear(undefined);
        setSelectedFromDate(null);
        setSelectedToDate(null);
        setSelectedFromTime(null);
        setSelectedToTime(null);
        handleFilters('', '')
    }, [resetTrigger]);

    useEffect(() => {
        if (filterOnlyMonth) {
            setTime('month');
            handleThisButton(dateService.getThisMonth(), true)
        }
    }, [filterOnlyMonth]);

    const handleDaySelect = (newDate: Dayjs | null): void => {
        setSelectedDayDate(newDate);
        setThisButton(false);
        setLastButton(false);
        setLast7Days(false)
        handleFilters(dateService.formatStartOfDay(newDate), dateService.formatEndOfDay(newDate))
    };

    const handleThisButton = ({ startDate, endDate }: { startDate: string; endDate: string }, timeChanged?: boolean) => {
        setSelectedDayDate(null)
        setLast7Days(false)
        if (timeChanged) {
            setThisButton(true);
            handleFilters(startDate, endDate)
        } else {
            setThisButton(!thisButton);
            if (thisButton) {
                handleFilters('', '')
            } else {
                handleFilters(startDate, endDate)
            }
        }

        setLastButton(false);
    }

    const handleLastButton = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
        setSelectedDayDate(null)
        setLastButton(!lastButton);
        setLast7Days(false)
        setThisButton(false);
        if (lastButton) {
            handleFilters('', '')
        } else {
            handleFilters(startDate, endDate)
        }
    }

    const handleLast7Days = ({startDate, endDate}: {startDate: string; endDate: string}) => {
        setLastButton(false);
        setThisButton(false);
        setLast7Days(!last7Days)
        if(last7Days) {
            handleFilters('', '')
        } else
        {
            handleFilters(startDate, endDate)
        }
    }

    const handleMonthYear = (year: string, month: string) => {
        const startDate = dayjs(`${year}-${month}-01`).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
        const endDate = dayjs(`${year}-${month}-01`).endOf('month').endOf('day').format('YYYY-MM-DDTHH:mm:ss');
        handleFilters(startDate, endDate);
    }

    const handleYear = (year: string) => {
        const startDate = dayjs(`${year}-01-01`).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
        const endDate = dayjs(`${year}-12-31`).endOf('day').format('YYYY-MM-DDTHH:mm:ss');

        handleFilters(startDate, endDate);
    };

    const handleInterval = (fromDate: Dayjs, toDate: Dayjs, fromTime?: string | null, toTime?: string | null) => {
        if (fromDate.isAfter(toDate, 'day')) {
            return;
        }

        const startDate = dateService.formatStartOfDay(fromDate, fromTime);
        const endDate = dateService.formatEndOfDay(toDate, toTime);

        handleFilters(startDate, endDate);
    };




    const renderTime = () => {
        switch (time) {
            case 'day':
                return (
                    <>
                        <div
                            className={`filter-button flex-row flex-align-center-center ${thisButton ? 'active' : ''}`}
                            onClick={() => handleThisButton(dateService.getToday())}
                        >
                            TODAY
                        </div>
                        <div
                            className={`filter-button flex-row flex-align-center-center ${lastButton ? 'active' : ''}`}
                            onClick={() => handleLastButton(dateService.getYesterday())}
                        >
                            YESTERDAY
                        </div>
                        <AppDatePicker
                            value={selectedDayDate}
                            onChange={handleDaySelect}
                            placeholder='Select DAY'
                            shouldDisableDate={(date) => date.isAfter(dayjs(), 'day')}
                        />
                    </>
                );
                case 'week':
                    return (
                        <>
                            <div
                                className={`filter-button flex-row flex-align-center-center ${thisButton ? 'active' : ''}`}
                                onClick={() => handleThisButton(dateService.getThisWeek())}
                            >
                                THIS WEEK
                            </div>
                            <div
                                className={`filter-button flex-row flex-align-center-center ${lastButton ? 'active' : ''}`}
                                onClick={() => handleLastButton(dateService.getLastWeek())}
                            >
                                LAST WEEK
                            </div>
                            <div
                                className={`filter-button flex-row flex-align-center-center ${last7Days ? 'active' : ''}`}
                                onClick={() => handleLast7Days(dateService.getLast7Days())}
                            >
                                LAST 7 DAYS
                            </div>
                        </>
                    );    
            case 'month':
                return (
                    <>
                        <div
                            className={`filter-button flex-row flex-align-center-center ${thisButton ? 'active' : ''}`}
                            onClick={() => handleThisButton(dateService.getThisMonth())}
                        >
                            THIS MONTH
                        </div>
                        <div
                            className={`filter-button flex-row flex-align-center-center ${lastButton ? 'active' : ''}`}
                            onClick={() => handleLastButton(dateService.getLastMonth())}
                        >
                            LAST MONTH
                        </div>
                        <AppSelect
                            theme='filter'
                            value={selectedMonth}
                            options={months}
                            onChange={(value) => {
                                setSelectedMonth(value);
                                setThisButton(false);
                                setLastButton(false);
                                if (value && selectedYear) {
                                    handleMonthYear(selectedYear, value);
                                }
                            }}
                            placeholder='Select MONTH'
                        />
                        <AppSelect
                            theme='filter'
                            value={selectedYear}
                            options={years}
                            onChange={(value) => {
                                setSelectedYear(value);
                                setThisButton(false);
                                setLastButton(false);
                                if (value && selectedMonth) {
                                    handleMonthYear(value, selectedMonth);
                                }
                            }}
                            placeholder='Select YEAR'
                        />
                    </>
                );
            case 'year':
                return (
                    <>
                        <div
                            className={`filter-button flex-row flex-align-center-center ${thisButton ? 'active' : ''}`}
                            onClick={() => handleThisButton(dateService.getThisYear())}
                        >
                            THIS YEAR
                        </div>
                        <div
                            className={`filter-button flex-row flex-align-center-center ${lastButton ? 'active' : ''}`}
                            onClick={() => handleLastButton(dateService.getLastYear())}
                        >
                            LAST YEAR
                        </div>
                        <AppSelect
                            theme='filter'
                            value={selectedYear}
                            options={years}
                            onChange={(value) => {
                                setSelectedYear(value);
                                setThisButton(false);
                                setLastButton(false);

                                if (value) {
                                    handleYear(value);
                                }
                            }}
                            placeholder='Select YEAR'
                        />
                    </>
                );
            case 'interval':
                return (
                    <>
                        <AppDatePicker
                            value={selectedFromDate}
                            onChange={(newDate) => {
                                setSelectedFromDate(newDate);
                                if (newDate && selectedToDate) {
                                    handleInterval(newDate, selectedToDate, selectedFromTime, selectedToTime);
                                }
                            }}
                            placeholder="Select DAY FROM"
                            shouldDisableDate={(date) =>
                                (selectedToDate && date.isAfter(selectedToDate, 'day')) || date.isAfter(dayjs(), 'day')
                            }
                        />
                        <AppTimePicker
                            value={selectedFromTime}
                            onChange={(newTime) => {
                                setSelectedFromTime(newTime);
                                if (selectedFromDate && selectedToDate) {
                                    handleInterval(selectedFromDate, selectedToDate, newTime, selectedToTime);
                                }
                            }}
                            placeholder="From Time"
                        />
                        <AppDatePicker
                            value={selectedToDate}
                            onChange={(newDate) => {
                                setSelectedToDate(newDate);
                                if (selectedFromDate && newDate) {
                                    handleInterval(selectedFromDate, newDate, selectedFromTime, selectedToTime);
                                }
                            }}
                            placeholder="Select DAY TO"
                            shouldDisableDate={(date) =>
                                (selectedFromDate && date.isBefore(selectedFromDate, 'day')) || date.isAfter(dayjs(), 'day')
                            }
                        />
                        <AppTimePicker
                            value={selectedToTime}
                            onChange={(newTime) => {
                                setSelectedToTime(newTime);
                                if (selectedFromDate && selectedToDate) {
                                    handleInterval(selectedFromDate, selectedToDate, selectedFromTime, newTime);
                                }
                            }}
                            placeholder="To Time"
                        />
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="time-filters flex-row flex-gap-20 flex-wrap">
            {!dontShowTransactionsNo &&
                <div className="transactions-number flex-row flex-align-center-center">
                    {transactionsNo} transactions
                </div>
            }
            <div className='time-selector'>
                <AppSelect
                    theme='filter'
                    value={filterOnlyMonth ? 'month' : time}
                    options={filterOnlyMonth ? timeOptionsMonth : timeOptions}
                    onChange={(value) => {
                        if (value === '' || value === undefined) {
                            // Reset case - clear all time filters
                            setTime(undefined);
                            setSelectedMonth('');
                            setSelectedYear('');
                            setSelectedDayDate(null);
                            setSelectedFromDate(null);
                            setSelectedToDate(null);
                            setThisButton(false);
                            setLastButton(false);
                            setLast7Days(false);
                            handleFilters('', '');
                        } else if (value == 'day') {
                            handleThisButton(dateService.getToday(), true)
                            setTime(value);
                        } else if(value == 'week') {
                            handleThisButton(dateService.getThisWeek(), true)
                            setTime(value);
                        } else if (value == 'month') {
                            handleThisButton(dateService.getThisMonth(), true)
                            setTime(value);
                        } else if (value == 'year') {
                            handleThisButton(dateService.getThisYear(), true)
                            setTime(value);
                        } else {
                            setTime(value);
                        }
                        setSelectedMonth('');
                        setSelectedYear('');
                        setSelectedDayDate(null);
                        setSelectedFromDate(null);
                        setSelectedToDate(null);
                        setSelectedFromTime(null);
                        setSelectedToTime(null);
                    }}
                    placeholder='TIME'
                />
            </div>
            {renderTime()}
        </div>
    );
}

export default TimeFilters;
